export default {
  none: Symbol('none'),
  pending: Symbol('pending'),
  success: Symbol('success'),
  cancel: Symbol('cancel'),
}
